<template>
  <div class="layout-wrapper" v-if="enableProcessingCluster">
    <v-card class="light-card">
        <v-toolbar color="primary" dark id="toolbar" class="title-add-sect">
          <v-card-title class="top-title">Processing Clusters</v-card-title>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="processingClusters"
          :options.sync="options"
          disable-pagination
          item-key="entity_id"
          class="light-table"
          hide-default-footer
        >
          <template v-slot:body="{ items }">
            <tbody>
              <ProcessingClusterItem
                v-for="(item, index) in items"
                :key="`processing_cluster_${index}`"
                :item="item"
                @openEditInterval="openEditInterval"
                @openAddPrincipal="openAddPrincipal"
                @openUpdateItemDialog="openUpdateItemDialog"
                @openLogs="openLogsDialog"
                @openDeleteItemDialog="openDeleteItemDialog"
                @openEditDialog="openEditDialog"
                @openSetUpSSL="openSetUpSSL"
                @openScaleCluster="openScaleCluster"
                @openStartStopClusterDialog="openStartStopClusterDialog"
              />
            </tbody>
          </template>
        </v-data-table>
        <div v-if="loadingProcessingClusters" class="text-center py-10">
          <v-progress-circular
            :size="70"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-card>
    <!--    Confirm Delete dialog-->
    <v-dialog v-model="dialogRemoveItem.open" persistent max-width="650">
      <v-card class="delete-dialog">
        <v-card-title class="headline dark--text">Please confirm</v-card-title>
        <v-card-text class="dark--text">Are you sure you want to delete <strong>{{dialogRemoveItem.name}}</strong>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="cancel-btn" text @click="dialogRemoveItem.open = false">Cancel</v-btn>
          <v-btn class="save-btn" text @click="apiDelete(dialogRemoveItem.entityId)">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    Confirm Update dialog-->
    <v-dialog v-model="dialogUpdateItem.open" persistent max-width="650">
      <v-card class="delete-dialog">
        <v-card-title class="headline dark--text">Please confirm</v-card-title>
        <v-card-text class="dark--text">Are you sure you want to update <strong>{{dialogUpdateItem.name}}</strong>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="cancel-btn" text @click="dialogUpdateItem.open = false">Cancel</v-btn>
          <v-btn class="save-btn" text @click="apiUpdate(dialogUpdateItem.entityId)">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--    Confirm Start Stop dialog-->
    <v-dialog v-model="dialogStartStopCluster.open" persistent max-width="650">
      <v-card class="delete-dialog">
        <v-card-title class="headline dark--text">Please confirm</v-card-title>
        <v-card-text class="dark--text">Are you sure you want to {{dialogStartStopCluster.start ? 'start' : 'stop'}}  <strong>{{dialogStartStopCluster.name}}</strong>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="cancel-btn" text @click="dialogStartStopCluster.open = false">Cancel</v-btn>
          <v-btn class="save-btn" text @click="startStopCluster(dialogStartStopCluster)">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSetUpSSL.open" persistent max-width="650">
      <v-card class="delete-dialog">
        <v-card-title class="headline dark--text">Please confirm</v-card-title>
        <v-card-text class="dark--text">Are you sure you want to setup SSL for <strong>{{dialogSetUpSSL.collector.name}}</strong>?</v-card-text>
        <v-form
                    ref="sslForm"
                    v-model="valid"
                    lazy-validation
                >
          <v-card-text class="d-flex">
            <v-text-field
              v-model="dialogSetUpSSL.collector.custom_ip"
              label="Custom IP"
              :rules="[v=> !v || valideIp(v) || 'Invalid IP']"
              style="width: 60%"
              class="mb-3 select-field"
              v-on:keyup.enter="setUpSSL(dialogSetUpSSL)"
            >
            </v-text-field>
            <v-text-field
              v-model="dialogSetUpSSL.collector.custom_port"
              label="Custom Port"
              style="width: 40%"
              class="mb-3 ml-2 select-field"
            >
            </v-text-field>
          </v-card-text>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="cancel-btn" text @click="dialogSetUpSSL.open = false">Cancel</v-btn>
          <v-btn class="save-btn" text @click="setUpSSL(dialogSetUpSSL)">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEdit.open"  attach max-width="650">
      <processing-cluster-editor :id="dialogEdit.entityId" v-if="dialogEdit.open" @resetEditDialog="resetEditDialog" editMode="Edit" />
    </v-dialog>

    <!--    Edit Interval dialog-->
    <v-dialog v-model="dialogEditInterval.open" attach max-width="450">
      <polling-interval
        :intervalDialog="dialogEditInterval"
        @editInterval="editInterval"
        @close="dialogEditInterval.open = false"
      />
    </v-dialog>

    <!--    Edit Scale Cluster dialog-->
    <v-dialog v-model="dialogScaleCluster.open" attach max-width="650">
      <v-card class="delete-dialog">
        <v-card-title class="headline dark--text mb-2">Scale Cluster</v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              label="Incoming File Processors"
              v-model="dialogScaleCluster.incoming_count"
              type="number" hide-details
              append-outer-icon="keyboard_arrow_right"
              @click:append-outer="incrementScaleClusterIncoming"
              prepend-icon="keyboard_arrow_left"
              @click:prepend="decrementScaleClusterIncoming"
              class="edit-interval"
            ></v-text-field>
            <v-text-field
              label="Content Processors"
              v-model="dialogScaleCluster.content_count"
              type="number" hide-details
              append-outer-icon="keyboard_arrow_right"
              @click:append-outer="incrementScaleClusterContent"
              prepend-icon="keyboard_arrow_left"
              @click:prepend="decrementScaleClusterContent"
              class="edit-interval mt-5"
            ></v-text-field>
          </v-form>
          <v-spacer></v-spacer>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="save-btn" depressed @click="scaleCluster(dialogScaleCluster)">Send</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--    Add Principal dialog-->
    <v-dialog v-model="dialogAddPrincipal.open" persistent max-width="650">
      <v-card class="delete-dialog">
        <v-card-title>Add Principal</v-card-title>
            <v-spacer></v-spacer>
            <v-card-text class="mb-0 pb-1 mt-6">Principal</v-card-text>
            <v-text-field
              label=""
              class="white--text ml-6 mr-6 mt-0 pt-2"
              solo
              v-model="dialogAddPrincipal.principal"
              type="text"
              name="input-10-1"
              validate-on-blur>
            </v-text-field>
            <v-card-text class="mb-0 pb-1">Password</v-card-text>
            <v-text-field
              label=""
              class="white--text ml-6 mr-6 mt-0 pt-2"
              solo
              v-model="dialogAddPrincipal.password"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              @click:append="showPassword = !showPassword"
              validate-on-blur
            />
            <v-card-text class="mb-0 pb-1">Server</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="cancel-btn" text @click="dialogAddPrincipal.open = false">Cancel</v-btn>
              <v-btn class="save-btn" @click="addPrincipal">Send</v-btn>
            </v-card-actions>
          <v-spacer></v-spacer>

      </v-card>
    </v-dialog>

    <!--Logs dialog-->
    <v-dialog content-class="logs-dialog-container resize" v-model="dialogLogs.open" persistent >
        <v-card class="logs-dialog">
          <v-card-actions>
            <div class="logs-title mb-4 mr-2">Processing Cluster Logs</div>
            <v-spacer></v-spacer>
            <v-select
                v-model="selectedColumns"
                :items="getColumns"
                label="Select Columns"
                multiple
                solo
                class="mt-2"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 5">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span
                    v-if="index === 5"
                    class="grey--text caption"
                  >
                    (+{{ selectedColumns.length - 5 }} others)
                  </span>
                </template>
            </v-select>
            <v-row class="d-flex flex-wrap flex-row">
              <v-col class="d-flex flex-row flex-wrap justify-center py-0" cols="12" lg="5" md="12" sm="12">
                <v-btn class="refresh-btn mb-4 ml-1" text @click="font--">-</v-btn>
                <div class="ml-2 mr-1 mb-4">{{font}}</div>
                <v-btn class="refresh-btn mb-4 ml-1 mr-1" text @click="font++">+</v-btn>
              </v-col>
              <v-col class="d-flex flex-row flex-wrap justify-center py-0" cols="12" lg="7" md="12" sm="12">
                <v-btn class="refresh-btn px-6 mb-4 mr-1" text @click="refreshLogs">Refresh</v-btn>
                <v-btn class="primary-btn px-6 mb-4" text @click="dialogLogs.open = false">close</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text class="logs-content dark--text" :style="{opacity: isLoading? 0.5 : 1 }">
              <v-data-table
                v-if="this.logs.length"
                :headers="getLogsHeader"
                :items="getLogsRecords"
                :server-items-length="processingClusters.length"
                :options.sync="options"
                item-key="entity_id"
                hide-default-footer
                fixed-header
                height="68vh"
                :ref="'logstable'"
              >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item,index) in items" :key="index">
                    <td v-if="selectedColumns.includes('Message')" :style="{maxWidth:'400px',fontSize: font+'px'}">
                      {{ formatMessage(item) }}
                      <span v-if="item.message.length > 100 " class="more-less" @click="expandMessage(item)"> {{ item.expanded ? " less" : " more" }} </span>
                    </td>
                    <td v-if="selectedColumns.includes('Value')" :style="{maxWidth:'400px',fontSize: font+'px'}">
                      {{ formatValue(item) }}
                      <span v-if="item.value.length > 100 " class="more-less" @click="expandValue(item)"> {{ item.expandedV ? " less" : " more" }} </span>
                    </td>
                    <td v-if="selectedColumns.includes('Job Type')" :style="{fontSize: font+'px'}" >{{item.JobType}}</td>
                    <td v-if="selectedColumns.includes('Stage')" :style="{fontSize: font+'px'}">{{item.Stage}}</td>
                    <td v-if="selectedColumns.includes('Total Files')" :style="{fontSize: font+'px'}">{{item.TotalFiles}}</td>
                    <td v-if="selectedColumns.includes('Total Folders')" :style="{fontSize: font+'px'}">{{item.TotalFolders}}</td>
                    <td v-if="selectedColumns.includes('Path Mappings')" :style="{fontSize: font+'px'}">{{item.PathMappings}}</td>
                    <td v-if="selectedColumns.includes('Scan Id')" :style="{fontSize: font+'px'}">{{item.ScanId}}</td>
                    <td v-if="selectedColumns.includes('Path')" :style="{fontSize: font+'px'}">{{item.Path}}</td>
                    <td v-if="selectedColumns.includes('Started')" :style="{fontSize: font+'px'}">{{item.Started}}</td>
                    <td v-if="selectedColumns.includes('Completed')" :style="{fontSize: font+'px'}">{{item.Completed}}</td>
                    <td v-if="selectedColumns.includes('Is Canceled')" :style="{fontSize: font+'px'}">{{item.IsCanceled}}</td>
                    <td v-if="selectedColumns.includes('Retry Count')" :style="{fontSize: font+'px'}">{{item.RetryCount}}</td>
                    <td v-if="selectedColumns.includes('Timestamp')" :style="{fontSize: font+'px'}">{{ localDate(item.timestamp) }}</td>
                  </tr>
                </tbody>
              </template>
              </v-data-table>
              <div v-if="noLogs" class="no-logs">
                <p>No more logs available</p>
              </div>
          </v-card-text>
          <div v-if="isLoading" class="progress-circle">
            <v-progress-circular
              :size="70"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validateNumbers } from '@/utils/main_helper'
import { validIpAddress } from '../../../components/utils/helpers'
import ProcessingClusterItem from './ProcessingClusterItem'
import ProcessingClusterEditor from '../../ProcessingCluster/ProcessingClusterEditor.vue'
import PollingInterval from '../shared/PollingInterval.vue'
import moment from 'moment'

export default {
  name: 'Processing_Cluster',
  components: {
    ProcessingClusterItem,
    ProcessingClusterEditor,
    PollingInterval
  },

  computed: {
    ...mapGetters(['processingClusters', 'api_keys', 'user', 'currentOrganization', 'loadingProcessingClusters', 'license']),
    enableProcessingCluster () {
      return this.license && this.license.enable_processing_cluster && this.license.enable_processing_cluster == true
    },
    times () {
      const res = []
      for (let i = 1; i <= 12; i++) {
        res.push(i)
      }
      return res
    },
    minutes () {
      const res = []
      for (let i = 0; i <= 59; i = i + 15) {
        res.push(i < 10 ? `0${i}` : i)
      }
      return res
    },
    getLogsRecords () {
      const res = []
      this.logs.map(log => {
        if (log.value) {
          res.push({ ...JSON.parse(log.value), value: log.value, message: log.message, timestamp: log.timestamp, expanded: false, expandedV: false })
        } else {
          res.push({ message: log.message, value: log.value, timestamp: log.timestamp, expanded: false, expandedV: false })
        }
      })
      return res
    },
    getColumns () {
      return this.headersLogs.map(log => log.text)
    },
    getLogsHeader () {
      return this.headersLogs.filter(log => this.selectedColumns.includes(log.text))
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
          align: 'left'
        },
        {
          text: 'Version',
          value: 'processingCluster_version',
          align: 'left'
        },
        {
          text: 'Polling Interval',
          value: 'intervals',
          align: 'left',
          sortable: false
        },
        {
          text: 'Manager',
          value: 'status'
        },
        {
          text: 'Cluster',
          value: 'cluster_status'
        },
        {
          text: 'Incoming/Content',
          value: 'incoming_count'
        },
        {
          text: '',
          value: 'actions',
          sortable: false
        }
      ],
      options: {
        page: 1,
        sortBy: ['changed_on'],
        itemsPerPage: 15
      },
      dialogRemoveItem: {
        open: false,
        name: '',
        entityId: ''
      },
      dialogUpdateItem: {
        open: false,
        name: '',
        entityId: ''
      },
      dialogStartStopCluster: {
        open: false,
        name: '',
        entityId: '',
        startStop: false
      },
      dialogSetUpSSL: {
        open: false,
        collector: {}
      },
      dialogEdit: {
        open: false,
        entityId: ''
      },
      dialogEditInterval: {
        open: false,
        value: 0,
        entityId: ''
      },
      dialogScaleCluster: {
        open: false,
        value: 0,
        entityId: '',
        incoming_count: null,
        content_count: null
      },
      dialogAddPrincipal: {
        open: false,
        principal: '',
        password: '',
        server: '',
        entityId: ''
      },
      dialogLogs: {
        open: false,
        item: null
      },
      showPassword: false,
      rules: {
        numeric: v => (!v || validateNumbers(v)) || 'Only numbers are allowed'
      },
      valid: true,
      font: 12,
      headersLogs: [
        {
          text: 'Message',
          value: 'message'
        },
        {
          text: 'Value',
          value: 'value'
        },
        {
          text: 'Job Type',
          value: 'JobType',
          align: 'left'
        },
        {
          text: 'Stage',
          value: 'Stage',
          align: 'left'
        },
        {
          text: 'Total Files',
          value: 'TotalFiles',
          align: 'left'
        },
        {
          text: 'Total Folders',
          value: 'TotalFolders'
        },
        {
          text: 'Path Mappings',
          value: 'PathMappings'
        },
        {
          text: 'Scan Id',
          value: 'ScanId'
        },
        {
          text: 'Path',
          value: 'Path'
        },
        {
          text: 'Started',
          value: 'Started'
        },
        {
          text: 'Completed',
          value: 'Completed'
        },
        {
          text: 'Is Canceled',
          value: 'IsCanceled'
        },
        {
          text: 'Retry Count',
          value: 'RetryCount'
        },
        {
          text: 'Timestamp',
          value: 'timestamp'
        }

      ],
      isLoading: false,
      logs: [],
      selectedColumns: [],
      scrollHeight: 0,
      wrapper: null,
      noLogs: false
    }
  },

  methods: {
    valideIp (ip) {
      return validIpAddress(ip)
    },
    openDeleteItemDialog (item) {
      this.dialogRemoveItem = {
        open: true,
        entityId: item.entity_id,
        name: item.name
      }
    },
    apiDelete (id) {
      this.dialogRemoveItem.open = false
      this.$store.dispatch('deleteProcessingCluster', id).then(() => {
        this.resetDialogRemoveItem()
      }).catch(console.error)
    },
    resetDialogRemoveItem () {
      this.dialogRemoveItem = {
        open: false,
        name: '',
        entityId: ''
      }
    },
    resetEditDialog () {
      this.dialogEdit = {
        open: false,
        entityId: ''
      }
    },
    resetDialogScaleCluster () {
      this.dialogScaleCluster = {
        open: false,
        value: null,
        entityId: '',
        incoming_count: null,
        content_count: null
      }
    },
    openEditDialog (item) {
      this.dialogEdit.open = true
      this.dialogEdit.entityId = item.entity_id
    },
    openScaleCluster (item) {
      this.dialogScaleCluster.open = true
      this.dialogScaleCluster.entityId = item.entity_id
      this.dialogScaleCluster.incoming_count = item.incoming_count
      this.dialogScaleCluster.content_count = item.content_count
    },
    openUpdateItemDialog (item) {
      this.dialogUpdateItem = {
        open: true,
        entityId: item.entity_id,
        name: item.name
      }
    },
    openStartStopClusterDialog (data) {
      this.dialogStartStopCluster = {
        open: true,
        entityId: data.item.entity_id,
        name: data.item.name,
        start: data.start
      }
    },
    openSetUpSSL (item) {
      this.dialogSetUpSSL = {
        open: true,
        collector: item
      }
    },
    apiUpdate (id) {
      this.dialogUpdateItem.open = false
      const command = {
        type: 'UPDATE',
        data: [{
          key: 'updatesUrl',
          value: process.env.VUE_APP_UPDATE_COLLECTOR
        }],
        organization_id: this.currentOrganization.entity_id,
        collector_id: this.dialogUpdateItem.entityId,
        status: 'pending'
      }
      this.$store.dispatch('postCommand', command).then(() => {
        this.resetDialogUpdateItem()
      }).catch(console.error)
    },
    resetDialogUpdateItem () {
      this.dialogUpdateItem = {
        open: false,
        name: '',
        entityId: ''
      }
    },
    resetDialogStartStopCluster () {
      this.dialogStartStopCluster = {
        open: false,
        name: '',
        entityId: '',
        start: false
      }
    },
    resetDialogSetUpSSL () {
      this.dialogSetUpSSL = {
        open: false,
        collector: {}
      }
    },
    resetDialogEditInterval () {
      this.dialogEditInterval = {
        open: false,
        value: null,
        entityId: ''
      }
    },
    openEditInterval (item) {
      this.dialogEditInterval.open = true
      this.dialogEditInterval.value = item.intervals
      this.dialogEditInterval.entityId = item.entity_id
    },
    openLogsDialog (item) {
      this.dialogLogs.open = true
      this.dialogLogs.item = item
      this.scrollHeight = 0
      this.isLoading = true
      this.getLogs()
    },
    editInterval (dialogEditInterval) {
      const command = {
        type: 'CHANGE_POLLING_INTERVAL',
        data: [{
          key: 'interval',
          value: dialogEditInterval.value
        }],
        organization_id: this.currentOrganization.entity_id,
        collector_id: dialogEditInterval.entityId,
        status: 'pending'
      }

      this.$store.dispatch('postCommand', command)

      const collectors = this.processingClusters.map(item => {
        if (item.entity_id === dialogEditInterval.entityId) {
          item.intervals = dialogEditInterval.value // important
        }
        return item
      })

      this.$store.commit('processingClustersLoaded', collectors)
      this.resetDialogEditInterval()
    },
    scaleCluster (dialogScaleCluster) {
      const command = {
        type: 'SET_WORKERS_COUNT',
        data: [
          {
            key: 'incoming_file_processors',
            value: dialogScaleCluster?.incoming_count
          },
          {
            key: 'content_processors',
            value: dialogScaleCluster?.content_count
          }
        ],
        organization_id: this.currentOrganization.entity_id,
        collector_id: dialogScaleCluster.entityId,
        status: 'pending'
      }

      this.$store.dispatch('postCommand', command)
      const collectors = this.processingClusters.map(item => {
        if (item.entity_id === dialogScaleCluster.entityId) {
          item.old_incoming_count = dialogScaleCluster.incoming_count
          item.old_content_count = dialogScaleCluster.content_count
        }
        return item
      })
      this.$store.commit('processingClustersLoaded', collectors)
      this.resetDialogScaleCluster()
    },
    startStopCluster (dialogStartStopCluster) {
      const command = {
        type: dialogStartStopCluster.start ? 'START_CLUSTER' : 'STOP_CLUSTER',
        organization_id: this.currentOrganization.entity_id,
        collector_id: dialogStartStopCluster.entityId,
        status: 'pending'
      }
      this.$store.dispatch('postCommand', command)
      this.resetDialogStartStopCluster()
    },
    async setUpSSL (dialogSetUpSSL) {
      this.$refs.sslForm.validate()
      if (!this.valid) return
      const res = await this.$store.dispatch('saveProcessingCluster', this.dialogSetUpSSL && this.dialogSetUpSSL.collector)
      console.log(res, 'gfds')
      const command = {
        type: 'SETUP_SSL',
        data: [
          {
            key: 'adminEmail',
            value: this.user.email
          }
        ],
        collector_id: dialogSetUpSSL.collector.entity_id,
        organization_id: this.currentOrganization.entity_id,
        status: 'pending'
      }

      if (this.dialogSetUpSSL.collector.custom_ip) {
        command.data.push({
          key: 'publicIp',
          value: dialogSetUpSSL.collector.custom_ip
        })
      }

      this.$store.dispatch('postCommand', command)
      this.resetDialogSetUpSSL()
    },
    incrementScaleClusterIncoming () {
      this.dialogScaleCluster.incoming_count = parseInt(this.dialogScaleCluster.incoming_count, 10) + 1
    },
    decrementScaleClusterIncoming () {
      this.dialogScaleCluster.incoming_count = parseInt(this.dialogScaleCluster.incoming_count, 10) - 1
    },
    incrementScaleClusterContent () {
      this.dialogScaleCluster.content_count = parseInt(this.dialogScaleCluster.content_count, 10) + 1
    },
    decrementScaleClusterContent () {
      this.dialogScaleCluster.content_count = parseInt(this.dialogScaleCluster.content_count, 10) - 1
    },
    resetDialogAddPrincipal () {
      this.dialogAddPrincipal = {
        open: false,
        value: null,
        password: '',
        principal: '',
        server: '',
        entityId: ''
      }
    },
    openAddPrincipal (item) {
      this.resetDialogAddPrincipal()
      this.dialogAddPrincipal.open = true
      this.dialogAddPrincipal.entityId = item.entity_id
      this.loadProcessingClusterDetails(item)
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    addPrincipal () {
      // Clone Dialog formData

      const resetHandler = this.resetDialogAddPrincipal

      // Sleep handler added because typing in a Combobox doesn't set the v-model value.
      // Without the sleep(), this.dialogAddPrincipal.server is blank when the dispatch() handler is called.
      this.sleep(100).then(() => {
        const principal = {
          collector_id: this.dialogAddPrincipal.entityId,
          organization_id: this.currentOrganization.entity_id,
          name: this.dialogAddPrincipal.principal,
          password: this.dialogAddPrincipal.password,
          server: this.dialogAddPrincipal.server
        }
        this.$store.dispatch('addPrincipal', principal).then(resetHandler)
      })
    },
    getStatusClass (status) {
      let className = 'grey'
      if (!status) {
        return className
      }
      switch (status.toLocaleLowerCase()) {
        case 'active':
          className = 'ok'
          break
        case 'warning':
          className = 'warning'
          break
        case 'offline':
          className = 'error'
          break
      }
      return className
    },
    fetchDashboardData () {
      this.$store.dispatch('dashboardServices/loadEnterpriseRiskData', { organizationId: this.currentOrganization.entity_id })
      this.$store.dispatch('dashboardServices/loadOverviewRiskData', { organizationId: this.currentOrganization.entity_id })
      this.$estore.dispatch('dashboardServices/loadZoomTreeMapData', { organizationId: this.currentOrganization.entity_id })
    },
    refreshLogs () {
      this.scrollHeight = 0
      this.isLoading = true
      this.getLogs()
    },
    getLogs () {
      this.noLogs = false
      this.$store.dispatch('getCollectorLogs', { organization_id: this.currentOrganization.entity_id, collector_id: this.dialogLogs.item.entity_id }).then(res => {
        this.logs = res.data ? res.data : []
        this.isLoading = false
        this.$nextTick(function () {
          this.addScrollEvent()
          this.autoLoadLogs()
        })
      })
    },
    addScrollEvent: function () {
      var dataTable = this.$refs.logstable
      if (dataTable !== undefined) {
        var wrapper = dataTable.$el.querySelector('.v-data-table__wrapper')
        wrapper.scrollTop = 0
        wrapper.addEventListener('scroll', this.scroll)
        this.wrapper = wrapper
      }
    },
    scroll (e) {
      if (e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight && !this.noLogs) {
        this.isLoading = true
        this.$store.dispatch('getCollectorLogs',
          {
            organization_id: this.currentOrganization.entity_id,
            collector_id: this.dialogLogs.item.entity_id,
            offset: this.logs.length
          }).then(res => {
          this.isLoading = false
          if (res.data && res.data.length) {
            this.logs = this.logs.concat(res.data)
          } else {
            this.noLogs = true
          }
        })
      }
    },
    autoLoadLogs () {
      // load more logs untill scroll-bar appear or response is not empty
      if (!(this.wrapper && this.wrapper.clientHeight < this.wrapper.scrollHeight)) {
        this.$store.dispatch('getCollectorLogs',
          {
            organization_id: this.currentOrganization.entity_id,
            collector_id: this.dialogLogs.item.entity_id,
            offset: this.logs.length
          }).then(res => {
          if (res.data && res.data.length) {
            this.logs = this.logs.concat(res.data)
            this.$nextTick(function () {
              var dataTable = this.$refs.logstable
              if (dataTable !== undefined) {
                var wrapper = dataTable.$el.querySelector('.v-data-table__wrapper')
                this.wrapper = wrapper
              }
              this.autoLoadLogs()
            })
          } else {
            this.noLogs = true
          }
        })
      }
    },
    formatMessage (item) {
      return item.expanded ? item.message : item.message.substring(0, 100)
    },
    formatValue (item) {
      return item.expandedV ? item.value : item.value.substring(0, 100)
    },
    expandMessage (item) {
      item.expanded = !item.expanded
    },
    expandValue (item) {
      item.expandedV = !item.expandedV
    },
    logValue (value) {
      let res = ''
      for (const key of Object.keys(value)) {
        res = res + key + ': ' + value[key] + ', '
      }
      return res
    },
    localDate (time) {
      const local = moment.utc(time, 'YYYY-MM-DD HH:mm:ss').local()
      return moment(local, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm:ss A')
    }
  },
  watch: {
  },
  mounted () {
    this.selectedColumns = ['Message', 'Value', 'Total Files', 'Total Folders', 'Path', 'Timestamp']
  },
  beforeDestroy () {
    if (this.wrapper) {
      this.wrapper.removeEventListener('scroll', this.scroll)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .edit-interval{
    .theme--light.v-icon {
      color: #BDC9D0;
    }
    input{
      color: #212338 !important;
      font-family: "gt_america", sans-serif !important;
    }
  }
}
.icon-basic {
    width: 42px;
    fill: white;
    z-index: 2;
  }
.v-input.white--text {
  .v-input__slot {
    background-color: rgba(255, 255, 255, 0.09) !important;
    box-shadow: none !important;
  }
  &.v-input--is-disabled {
    .v-input__slot {
      background-color: rgba(255, 255, 255, 0.05) !important;
    }
  }
}
.v-select__selection--comma {
  margin: 0px !important;
}
.logs-dialog-container{
  background: white;
  .logs-dialog{
    height: 85vh;
    .v-card__text{
      padding: 0;
    }
    .logs-title{
      font-size: 24px;
      margin-left: 12px;
    }
  }
  .font-btn{
    min-width: 50px !important;
    width: 50px !important;
    font-weight: bold;
    &:hover{
      background: $primary-color;
      opacity: 1;
      .v-btn__content {
        color: #fff;
      }
    }
  }
  .more-less{
    text-decoration: underline;
    color: blue !important;
    cursor: pointer;
  }
  .progress-circle{
    position: absolute;
    left: 50%;
    top: 50%;
  }
  .logs-content{
    margin-top: -10px;
  }
  .no-logs{
    width: 100%;
    text-align: center;
    margin: 10px 0px;
    font-weight: bold;
    color: #777;
    background: white;
  }
  .refresh-btn {
    border-radius: 50px;
    background: transparent;
    border: 1px solid $primary-color;
    border-radius: 50px;
    text-transform: uppercase !important;
    letter-spacing: 1.97321px !important;
    text-transform: uppercase;
    font-weight: bold !important;
    color: $primary-color !important;

    .v-btn__content {
      box-shadow: none;
      font-weight: bold;
      font-size: 14px;
      line-height: 35px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 2px;
      text-transform: uppercase;
    }
    .v-btn__content:hover {
      color: #212338 !important;
    }
  }
}
input[type="time"] {
    font-family: "gt_america_extended";
    padding-inline-start: 1px;
    font-size: 16px;
    outline: none;
    padding-bottom: 5px;
    border-bottom: 1px solid black;
}
</style>
<style lang="sass">
=box($w ,$h:$w)
  width: $w
  height: $h

.resize
  +box(100%,100%)
  resize: both
</style>
